import { isDesktop } from "coremh/components/utils";
const contentTileCarousel = require("coremh/components/contentTilesCarousel.js");

/**
 *  Remove active class for previous selected tab
 */
const initTabs = () => {
    let $loyaltyTabs = $(".js-tab-loyalty");
    if ($loyaltyTabs.length) {
        let tabs = $loyaltyTabs.find(".nav-item").toArray();
        let hasActiveClass = tabs.filter((item, index) => $(item).hasClass("active")); // eslint-disable-line

        if (!hasActiveClass.length) {
            $(tabs[0]).addClass("active").find(".tab-link").addClass("active");
        }
    }

    $("a[data-toggle='tab']").on("show.bs.tab", function () {
        $(".js-content-tab-carousel .tab-link").removeClass("active");
        $(this).addClass("active");
    });

    $("a[data-toggle='tab']").on("shown.bs.tab", function (e) {
        var tabID = $(e.target).attr("href");
        var $tabEl = $(tabID);

        if ($tabEl.length > 0) {
            var $selectedCarousel = $tabEl.find(".js-content-tiles-carousel");

            if ($selectedCarousel.length && !$selectedCarousel.hasClass("slick-initialized")) {
                contentTileCarousel.initContentTileCarousel($selectedCarousel);
            }
        }
    });
};

/**
 *  Init carousel for tabs
 */
const initCarousel = () => {
    var $tabSlider = $(".js-content-tab-carousel");

    if ($tabSlider.length > 0) {
        let slidesScrollGap = 2;
        let $items = $tabSlider.find(".nav-item").toArray();
        let $activeItem = $tabSlider.find(".nav-item.active");
        let activeIndex = $items.indexOf($activeItem.get(0));
        let totalWidth = $items.reduce((acc, el) => $(el).width() + acc, 0);
        let wrapperWidth = $tabSlider.width();
        let loyalty = $tabSlider.hasClass("js-tab-loyalty");

        if ((loyalty && totalWidth > wrapperWidth) || !loyalty) {
            $tabSlider.slick({
                lazyLoad: "ondemand",
                "slidesToShow": 1,
                pauseOnFocus: false,
                mobileFirst: true,
                variableWidth: true,
                infinite: false,
                arrows: false
            });

            $tabSlider.get(0).slick.slickGoTo(activeIndex > slidesScrollGap ? activeIndex - slidesScrollGap : 0);
        }
    }
};

export default function () {
    initTabs();

    if (!isDesktop()) {
        initCarousel();
    }
}
